import React, {FunctionComponent, Fragment, useContext, useMemo, useState} from 'react';
import {observer} from "mobx-react";
import TranslatedText from "../../../ui/TranslatedText/TranslatedText";
import {TextField, Typography} from "@material-ui/core";
import UITranslations from "../../../../store/uiTranslations";
import {Context} from "../../../../store/context";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import TranslatedNode from "../../../ui/TranslatedNode/TranslatedNode";
import _ from 'lodash';
import {INode} from "../../../../types/INode";
import makeStyles from "@material-ui/core/styles/makeStyles";
import Grid from "@material-ui/core/Grid";
import FormControl from "@material-ui/core/FormControl";
import grey from "@material-ui/core/colors/grey";

interface ISelectParkingItem {
    onNodeSelected: (node:INode|undefined) => void;
}

const useStyles = makeStyles(theme => ({
    selectParkingItem__dropdownContainer:{
        width:"100%",
        maxWidth:"300px",
        paddingLeft:theme.spacing(4)
    },
    select__placeholderItem:{
        fontStyle:"italic"
    }
}));

const SelectParkingItem:FunctionComponent<ISelectParkingItem> = ({onNodeSelected}) => {
    const ui = UITranslations.GettingToPage.Wizard.Parking;
    const classes = useStyles();

    const {destCategoriesStore, nodesStore, gettingToPageStore} = useContext(Context);
    const parkingNodes: INode[] = useMemo(() => {
        const destIds = destCategoriesStore.parkingDestinations.map(d => d.destination_id);
        return _.uniq(nodesStore.nodes.filter(n => n.destinations.find(d => destIds.includes(d.destinationId))));
    }, [destCategoriesStore.parkingDestinations, nodesStore.nodes]);

    const handleSelectChange = (e) => {
        gettingToPageStore.setSelectedParkingId(e.target.value);

        const node = nodesStore.nodes.find(n => n.id == e.target.value);
        onNodeSelected(node);
    }

    return <Fragment>
        <Typography gutterBottom>
            <TranslatedText source={ui.SaveLocation}/>
        </Typography>
        <Grid container>
            <FormControl classes={{root: classes.selectParkingItem__dropdownContainer}}>
                <Select displayEmpty value={gettingToPageStore.selectedParkingId}
                        onChange={handleSelectChange}>
                    <MenuItem value="">
                        <Typography classes={{root:classes.select__placeholderItem}}>
                            <TranslatedText source={ui.PleaseSelectPlaceholder}/>
                        </Typography>
                    </MenuItem>
                    {
                        parkingNodes.map(n =>
                            <MenuItem key={n.id} value={n.id.toString()}>
                                <TranslatedNode id={n.id}/>
                            </MenuItem>
                        )
                    }
                </Select>
            </FormControl>
        </Grid>
    </Fragment>
}

export default observer(SelectParkingItem);
